import { useEffect } from 'react';

import {
  clearSessionCache,
  getIdentityInstance,
} from '../../services/schibstedAccount';
import { access as svpAccess } from '../../services/svp/access';

import type { Identity } from '@schibsted/account-sdk-browser/src/identity';

export const useSessionInvalidation = ({
  disabled,
}: { disabled?: boolean } = {}) => {
  // clear identity and monetization cache before starting the payment flow,
  // for the user to be logged in / have correct accesses when returning from the flow
  useEffect(() => {
    if (disabled) {
      return;
    }

    let identity: Identity | undefined;

    (async () => {
      try {
        identity = await getIdentityInstance();

        // if the call to the hasSession service fails in any way (e.g. the user is not logged in),
        // then the identity instance emits `error` event
        // ref https://github.com/schibsted/account-sdk-browser/blob/master/src/identity.js#L524
        identity.on('error', clearSessionCache);

        clearSessionCache();

        await svpAccess.clearAccessCache();
      } catch (err) {
        console.error(err);
      }
    })();

    return () => {
      if (identity) {
        identity.off('error', clearSessionCache);
      }
    };
  }, [disabled]);
};
